<template>
  <div class="wrapper" id="App">
    <header>
      <!-- 交通資訊的頭 -->
      <nav class="navbar navbar-map" style="display: none">
        <!-- 0519 新增連結 回上頁和回首頁 -->
        <div class="box">
          <a href="javascript:history.back()" style="margin-top: -5px; margin-bottom: -4px">
            <span>＜</span>
          </a>
        </div>
        <div class="box">
          <router-link :to="{ name: 'Home' }" style="margin-top: -5px; margin-bottom: -4px">
            <img src="img/home.svg" alt="" />
          </router-link>
        </div>
      </nav>
      <!-- 頭 -->
      <nav class="navbar navbar-default">
        <!-- 0519 新增a連結 增加連結 -->
        <div class="logo-box">
          <router-link :to="{ name: 'Home' }" class="logo-link">
            <img ref="siteLogo" class="site-logo" v-if="NavData == null || NavData.SiteLogo == ''" src="img/logo-2.svg"
              alt="" @load="syncHomeIconHeight" />
            <img ref="siteLogo" class="site-logo" v-if="NavData != null && NavData.SiteLogo != ''"
              :src="NavData.SiteLogo" alt="" @load="syncHomeIconHeight" />
            <img ref="homeIcon" class="home-icon" src="img/home4.png" alt="" />
          </router-link>
        </div>
        <!-- 0519 新增 box div 包住網頁版選單/中英切換紐/img -->
        <div class="box">
          <!-- 0519 新增 web-menu div -->
          <div class="web-menu">
            <ul class="menu-box">
              <li v-if="local != 'jp'">
                <router-link :to="{ name: 'MProductList' }">
                  <img class="svg icon" src="img/menu-package.svg" alt="favorite" />
                  <p class="icon-add">{{ $t("關於套票") }}</p>
                </router-link>
              </li>
              <li v-if="local == 'jp'">
                <router-link :to="{ name: 'ProductList' }">
                  <img class="svg icon" src="img/menu-package.svg" alt="favorite" />
                  <p class="icon-add">{{ $t("關於套票") }}</p>
                </router-link>
              </li>
              <li v-if="local != 'jp'">
                <!-- 0519 增加 連結  -->
                <router-link :to="{ name: 'Map' }">
                  <img class="svg icon" src="img/menu-map.svg" alt="favorite" />
                  <p>{{ $t("交通導覽") }}</p>
                </router-link>
              </li>
              <li v-if="local == 'jp'">
                <!-- 0519 增加 連結  -->
                <a href="https://jp.taiwan.net.tw/m1.aspx?sNo=0003121" target="_blank">
                  <img class="svg icon" src="img/menu-map.svg" alt="favorite" />
                  <p>{{ $t("交通導覽") }}</p>
                </a>
              </li>
              <li v-if="LoginToken != ''">
                <router-link :to="{ name: 'MemberInfo' }">
                  <img class="svg icon" src="img/menu-member.svg" alt="" />
                  <p>{{ $t("我的會員") }}</p>
                </router-link>
              </li>
              <li v-if="LoginToken == ''">
                <router-link :to="{ name: 'Login' }">
                  <img class="svg icon" src="img/menu-member.svg" alt="" />
                  <p>{{ $t("會員登入") }}</p>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'OtherList' }">
                  <img class="svg icon" src="img/menu-travel.svg" alt="favorite" />
                  <p>{{ $t("其他資訊") }}</p>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- 0517 新增 btn-box div -->
          <div class="btn-box">
            <!-- <button v-if="local == 'zh_tw'" @click="changeLang('en')">
              EN
            </button>
            <button v-if="local == 'en'" @click="changeLang('zh_tw')">
              TW
            </button> -->
            <div class="form-group">
              <label for="langSelect"><img src="img/language.svg" alt="" /></label>
              <select class="form-control" id="langSelect" @change="changeLang(local)" v-model="local">
                <option value="en">EN</option>
                <option value="jp">JP</option>
                <option value="zh_tw">TW</option>
              </select>
            </div>
          </div>
          <div class="img-box">
            <img src="img/doll-3.svg" alt="" />
          </div>
        </div>
        <!-- <div class="search-box">
            <div class="input-group">
                <input type="text" class="form-control" placeholder="搜尋">
                <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" id="button-addon2"> <span>></span> </button>
                </div>
            </div>
            </div> -->
      </nav>
      <!-- 0520 新增 網頁板右下角QR扣 -->
      <a style="cursor: pointer" @click="gotoQRCode()" class="qrcode-box" v-if="LoginToken != ''">
        <div class="img-box">
          <img src="img/menu-qrcode.svg" alt="" />
        </div>
      </a>
      <!-- 底部固定選單 -->
      <nav class="nav-menu">
        <ul class="menu-box">
          <li v-if="local != 'jp'">
            <!-- 0518 增加變色的class"menu-active"　換掉img -->
            <router-link :to="{ name: 'MProductList' }">
              <img class="svg icon" src="img/menu-package.svg" alt="favorite" />
              <p class="icon-add">{{ $t("關於套票") }}</p>
            </router-link>
          </li>
          <li v-if="local == 'jp'">
            <!-- 0518 增加變色的class"menu-active"　換掉img -->
            <router-link :to="{ name: 'ProductList' }">
              <img class="svg icon" src="img/menu-package.svg" alt="favorite" />
              <p class="icon-add">{{ $t("關於套票") }}</p>
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <!-- 0519 增加 連結  -->
            <router-link :to="{ name: 'Map' }">
              <img class="svg icon" src="img/menu-map.svg" alt="favorite" />
              <p>{{ $t("交通導覽") }}</p>
            </router-link>
          </li>
          <li v-if="local == 'jp'">
            <!-- 0519 增加 連結  -->
            <a style="cursor: pointer" @click="
              gotoUrl('https://jp.taiwan.net.tw/m1.aspx?sNo=0003121', true)
              ">
              <img class="svg icon" src="img/menu-map.svg" alt="favorite" />
              <p>{{ $t("交通導覽") }}</p>
            </a>
          </li>
          <li class="menu-qrcode" v-if="LoginToken != ''">
            <a style="cursor: pointer" @click="gotoQRCode()">s
              <div class="img-box">
                <img src="img/menu-qrcode.svg" alt="" />
              </div>
              <p>{{ $t("電子票券") }}</p>
            </a>
          </li>
          <li v-if="LoginToken != ''">
            <router-link :to="{ name: 'MemberInfo' }">
              <img class="svg icon" src="img/menu-member.svg" alt="" />
              <p>{{ $t("我的會員") }}</p>
            </router-link>
          </li>
          <li v-if="LoginToken == ''">
            <router-link :to="{ name: 'Login' }">
              <img class="svg icon" src="img/menu-member.svg" alt="" />
              <p>{{ $t("會員登入") }}</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OtherList' }">
              <img class="svg icon" src="img/menu-travel.svg" alt="favorite" />
              <p>{{ $t("其他資訊") }}</p>
            </router-link>
          </li>
        </ul>
      </nav>
      <!-- 0623 新增 返回鍵按鈕 -->
      <div class="back-btn" @click="gotoBack()" v-if="isMobile && this.$route.name != 'Home'">
        <button><img src="img/back-icon.png" alt="" /></button>
      </div>
    </header>
    <router-view></router-view>
    <footer>
      <div class="container">
        <div class="footer-box">
          <div class="text-box" v-html="FooterData.Footer_Text"></div>
          <div class="box">
            <div class="download">
              <a style="cursor: pointer" v-if="FooterData.AppStore_Url == '' ? false : true"
                v-on:click="gotoAppStore"><img src="img/App-Store.svg" alt="" /></a>
              <a style="cursor: pointer" v-if="FooterData.GooglePlay_Url == '' ? false : true"
                v-on:click="gotoGooglePlay"><img src="img/Google-Play.svg" alt="" /></a>
            </div>
            <ul class="social">
              <li>
                <a style="cursor: pointer" v-if="FooterData.Facebook_Url == '' ? false : true"
                  @click="gotoUrl(FooterData.Facebook_Url, true)">
                  <img src="img/icon-fb.svg" alt="" />
                </a>
              </li>
              <li>
                <a style="cursor: pointer" v-if="FooterData.Line_Url == '' ? false : true"
                  @click="gotoUrl(FooterData.Line_Url, true)">
                  <img src="img/icon-line.svg" alt="" />
                </a>
              </li>
              <li>
                <a style="cursor: pointer" v-if="FooterData.Youtube_Url == '' ? false : true"
                  @click="gotoUrl(FooterData.Youtube_Url, true)">
                  <img src="img/icon-youtube.svg" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="div"></div>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    關於套票: "關於套票",
    交通導覽: "交通導覽",
    其他資訊: "其他資訊",
    我的會員: "我的會員",
    會員登入: "會員登入",
    電子票券: "電子票券",
    錯誤: "錯誤",
    確定: "確定",
    "取得QRCode過程發生錯誤, 請稍後再試一次":
      "取得QRCode過程發生錯誤, 請稍後再試一次",
    請選擇要使用的票卡: "請選擇要使用的票卡",
    天數票: "天數票",
    時數票: "時數票",
    取消: "取消",
    無可用的票卡: "無可用的票卡",
    無可用的QR套票: "無可用的QR套票",
    你的帳號中沒有可用的QRCode票卡: "你的帳號中沒有可用的QRCode票卡",
  },
  en: {
    關於套票: "About pass",
    交通導覽: "Navigation",
    其他資訊: "Info",
    我的會員: "Member",
    會員登入: "Log in",
    電子票券: "QR Code",
    錯誤: "Error",
    確定: "Confirm",
    "取得QRCode過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    請選擇要使用的票卡: "Please select the pass.",
    天數票: "Monthly/Weekly pass",
    時數票: "Hour pass",
    取消: "Cancel",
    無可用的票卡: "No pass available.",
    無可用的QR套票: "No QR Code pass available.",
    你的帳號中沒有可用的QRCode票卡:
      "There are no QR Code pass available in your account.",
  },
  jp: {
    關於套票: "チクットについて",
    交通導覽: "おすすめの場所",
    其他資訊: "その他",
    我的會員: "メンバー",
    會員登入: "会員ログイン",
    電子票券: "電子票券",
    錯誤: "錯誤",
    確定: "確定",
    "取得QRCode過程發生錯誤, 請稍後再試一次":
      "取得QRCode過程發生錯誤, 請稍後再試一次",
    請選擇要使用的票卡: "請選擇要使用的票卡",
    天數票: "天數票",
    時數票: "フリーパス",
    取消: "取消",
    無可用的票卡: "無可用的票卡",
    無可用的QR套票: "無可用的QR套票",
    你的帳號中沒有可用的QRCode票卡: "你的帳號中沒有可用的QRCode票卡",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "App",
  i18n,
  data() {
    return {
      NavData: {},
      FooterData: {},
      LoginToken: "",
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      isiOS: false,
      localVer: "",
      local: "zh_tw",
      timeTry: 0,
      deepLinkProcessed: false, // Deep Link 處理標記
      lastDeepLinkUrl: "", // 記錄最後處理的 Deep Link URL
    };
  },
  created: function () {
    this.localVer = this.GLOBAL.localVer;
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Nav", {
        params: { lang: Storage.get("ek_site_lang") },
      })
      .then((response) => {
        this.NavData = response.data;
      })
      .catch((error) => {
        this.$swal({
          title: this.$t("錯誤"),
          text: "無法連線至網際網路，請確認您的連線狀態後再試一次。",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("重新整理"),
          willClose: function () {
            location.reload();
          },
        });
        console.log(error);
      });
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Footer", {
        params: { lang: Storage.get("ek_site_lang") },
      })
      .then((response) => {
        this.FooterData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // // 未登入的話重覆確認(1s)
    // let that = this;
    // var timeTry = 0;
    // var loopToken = window.setInterval(function () {
    //   // 確認Token合法性
    //   if (this.$cookies.isKey("ek_login_token")) {
    //     that.LoginToken = this.$cookies.get("ek_login_token");
    //     $.ajax({
    //       url:
    //         that.GLOBAL.apiSrc +
    //         that.GLOBAL.subDirectory +
    //         "/Htmlv2/LoginCheck",
    //       type: "post",
    //       data: {
    //         token: that.LoginToken,
    //       },
    //       dataType: "json",
    //       error: function () {
    //       },
    //       success: function (res) {
    //         // 判斷結果
    //         if (res.error) {
    //           window.clearInterval(loopToken);
    //           that.$swal({
    //             title: that.$t("錯誤"),
    //             text: i18n.locale == "en" ? res.error_en : res.error,
    //             icon: "error",
    //             allowOutsideClick: false,
    //             confirmButtonText: that.$t("確定"),
    //             willClose: function () {
    //               // 移除登入資訊
    //               that.$cookies.remove("ek_login_token");
    //               //location.reload();
    //               // 返回首頁
    //               location.href = "/#/";
    //               location.reload();
    //             },
    //           });
    //         } else {
    //           window.clearInterval(loopToken);
    //         }
    //       },
    //     });
    //   }
    //   // 最多測試10秒(50次)
    //   timeTry += 1;
    //   if (timeTry >= 50) {
    //     window.clearInterval(loopToken);
    //   }
    // }, 1000);
    // 登入判斷
    this.loginCheck();
    if (this.isMobile && navigator.userAgent.match(/(Android)/i) == null) {
      this.isiOS = true;
    }
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
      this.local = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }

    // Deep Link 監聽 (Widget 與外部 App 串接功能)
    let that = this;

    function handleDeepLink(url) {
      let normalizedUrl = String(url || "");

      // Android 背景喚醒時，custom URL scheme plugin 可能傳入編碼後的 URL。
      try {
        normalizedUrl = decodeURIComponent(normalizedUrl);
      } catch (error) {
        console.log("Deep Link decode failed:", error);
      }

      console.log("Deep Link received:", normalizedUrl);

      if (normalizedUrl.indexOf('MQRCode') === -1 && normalizedUrl.indexOf('mengo://') === -1) {
        return;
      }

      // 防止 iOS / Android 在短時間內重複處理同一個 Deep Link。
      if (that.lastDeepLinkUrl === normalizedUrl && that.deepLinkProcessed) {
        console.log("Deep Link already processed, ignoring");
        return;
      }

      that.lastDeepLinkUrl = normalizedUrl;
      that.deepLinkProcessed = true;

      setTimeout(function () {
        const isCouponDeepLink = /^mengo:\/\/MQRCode(?:[/?#]|$)/i.test(normalizedUrl) &&
          /[?&]target=Coupon(?:[&#]|$)/i.test(normalizedUrl);

        if (isCouponDeepLink) {
          that.$router.push({ name: "Coupon" });
        } else {
          that.gotoQRCode();
        }

        // 3秒後重置標記，允許下次點擊 Deep Link。
        setTimeout(function () {
          that.deepLinkProcessed = false;
          that.lastDeepLinkUrl = "";
        }, 3000);
      }, 100);
    }

    // 監聽 handleOpenURL (iOS + cordova-plugin-customurlscheme)
    window.handleOpenURL = handleDeepLink;

    // 監聽 Android Intent
    if (typeof cordova !== 'undefined' && typeof device !== 'undefined' && device.platform === 'Android') {
      window.plugins && window.plugins.intent && window.plugins.intent.setNewIntentHandler(function (intent) {
        console.log("Android Intent received:", intent);

        if (intent.data) {
          handleDeepLink(intent.data);
        }
      });
    }
    window.addEventListener("resize", this.syncHomeIconHeight);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.syncHomeIconHeight);
  },
  methods: {
    syncHomeIconHeight: function () {
      this.$nextTick(() => {
        var siteLogo = this.$refs.siteLogo;
        var homeIcon = this.$refs.homeIcon;

        if (siteLogo && homeIcon) {
          homeIcon.style.height = siteLogo.getBoundingClientRect().height + "px";
        }
      });
    },
    logout: function (lang) {
      Storage.remove("ek_login_token");
      //location.reload();
      // 返回首頁
      location.href = "/#/";
      location.reload();
    },
    gotoQRCode: function () {
      let that = this;

      // 檢查是否已登入
      if (!Storage.isKey("ek_login_token") || !Storage.get("ek_login_token")) {
        that.$swal({
          //title: that.$t("錯誤"),
          text: "請先登入會員",
          icon: "warning",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        }).then(() => {
          that.$router.push({
            name: "Login",
            params: {},
          });
        });
        return;
      }

      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/CheckQRCode",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        async: false,
        error: function () {
          that.$swal({
            title: that.$t("錯誤"),
            text: that.$t("取得QRCode過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            if (res.QRCode && !res.MQRCode) {
              that.$router.push({
                name: "QRCode",
                params: {},
              });
            } else if (!res.QRCode && res.MQRCode) {
              that.$router.push({
                name: "MQRCode",
                params: {},
              });
            } else if (res.QRCode && res.MQRCode) {
              that
                .$swal({
                  title: "請選擇要使用的票卡",
                  allowOutsideClick: false,
                  showDenyButton: true,
                  showCancelButton: true,
                  confirmButtonText: "月週票",
                  denyButtonText: "時數票",
                  cancelButtonText: "取消",
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    that.$router.push({
                      name: "MQRCode",
                      params: {},
                    });
                  } else if (result.isDenied) {
                    that.$router.push({
                      name: "QRCode",
                      params: {},
                    });
                  }
                });
            } else {
              that.$swal({
                title: that.$t("無可用的QR套票"),
                text: that.$t("你的帳號中沒有可用的QRCode票卡"),
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          } else if (res.error) {
            if (res.token_error) {
              // 移除登入資訊
              Storage.remove("ek_login_token");
              that.LoginToken = "";
              // that.$router.push({
              //   name: "MemberInfo",
              //   params: {},
              // });
              that.$swal({
                title: that.$t("錯誤"),
                text: i18n.locale == "en" ? res.error_en : res.error,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              }).then(() => {
                // 導向登入頁面
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              });
            } else {
              that.$swal({
                title: that.$t("錯誤"),
                text: i18n.locale == "en" ? res.error_en : res.error,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              }).then(() => {
                // 導向登入頁面
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              });
            }
          }
        },
      });
    },
    gotoCategory: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPost: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url, Blank) {
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          Url,
          "_blank",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
          this.$t("關閉") +
          ",closebuttoncolor=#ffffff"
        );
      } else {
        if (Blank) {
          window.open(Url, "_blank");
        } else {
          window.open(Url);
        }
      }
    },
    gotoBack: function () {
      // 取得記錄
      var routerHistory = [];
      if (Storage.isKey("routerHistory")) {
        var routerHistoryInfo = Storage.get("routerHistory");
        if (typeof routerHistoryInfo == "object") {
          routerHistory = routerHistoryInfo;
        } else {
          routerHistory = JSON.parse(routerHistoryInfo);
        }
      }
      if (routerHistory.length > 0) {
        var prevPath = routerHistory.pop();
        this.$router.push(prevPath);
        Storage.set("routerHistory", JSON.stringify(routerHistory));
      }
      //this.$router.go(-1);
    },
    changeLang: function (lang) {
      Storage.set("ek_site_lang", lang, "30d");
      //location.reload();
      // 返回首頁
      location.href = "/#/";
      location.reload();
    },
    gotoAppStore: function (event) {
      window.open(this.FooterData.AppStore_Url);
    },
    gotoGooglePlay: function (event) {
      window.open(this.FooterData.GooglePlay_Url);
    },
    loginCheck: function () {
      // 確認Token合法性
      if (Storage.isKey("ek_login_token")) {
        this.LoginToken = Storage.get("ek_login_token");
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/LoginCheck",
          type: "post",
          data: {
            token: that.LoginToken,
          },
          dataType: "json",
          error: function () {
            // 連線失敗時重覆確認
            if (that.timeTry < 10) {
              that.timeTry += 1;
              that.loginCheck();
            }
          },
          success: function (res) {
            // 判斷結果
            if (res.error) {
              that.$swal({
                title: that.$t("錯誤"),
                text: i18n.locale == "en" ? res.error_en : res.error,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  //location.reload();
                  // 返回首頁
                  location.href = "/#/";
                  location.reload();
                },
              });
            }
          },
        });
      }
    },
  },
  updated: function () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.site-logo {
  flex: 0 0 100%;
}

.home-icon {
  flex: 0 0 auto;
  width: auto;
  object-fit: contain;
  max-height: 24px;
  margin-top: -6px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue